/**
 * Token Provider Singleton
 *
 * Provides a centralized way to access authentication tokens
 * This allows BaseService to retrieve tokens without direct dependency on React context
 */

type TokenProviderFunction = () => Promise<string | null>;

class TokenProvider {
  private tokenProviderFn: TokenProviderFunction | null = null;

  /**
   * Register the token provider function (called once during app initialization)
   */
  setTokenProvider(fn: TokenProviderFunction): void {
    this.tokenProviderFn = fn;
  }

  /**
   * Get the current access token
   */
  async getAccessToken(): Promise<string | null> {
    if (!this.tokenProviderFn) {
      console.warn('Token provider not initialized. User may not be authenticated.');
      return null;
    }

    try {
      return await this.tokenProviderFn();
    } catch (error) {
      console.error('Error retrieving access token:', error);
      return null;
    }
  }

  /**
   * Clear the token provider (used during logout or cleanup)
   */
  clearTokenProvider(): void {
    this.tokenProviderFn = null;
  }
}

// Export singleton instance
export const tokenProvider = new TokenProvider();
